import { IOption } from "../../../../../../components/selects/select";
import { TFunction } from "react-i18next"

export const InternetOrderGetInfoOptions = (t: TFunction): IOption[] => [
    { displayName: t("sysOptions.InternetOrderGetInfo.Yes"), value: t("sysOptions.InternetOrderGetInfo.Yes") },
    { displayName: t("sysOptions.InternetOrderGetInfo.No"), value: t("sysOptions.InternetOrderGetInfo.No") },
]